import { Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { SeFeApiService } from 'se-fe-api'
import { Group } from 'se-resource-types/dist/lib/Ngin'
import { ApiResponse } from 'se-resource-types/lib/common'


export interface ArchiveGroupParams {
  id: string | number
  archived: boolean
  type: string
  name?: string // optional name for smart groups
}

@Injectable({
  providedIn: 'root'
})
export class GroupService {
  public endpoint = 'ngin/v2/groups'

  constructor(
    private api: SeFeApiService
  ) {
    // noop
  }

  public findAll(params: any): Observable<ApiResponse<Group[]>> {
    return this.api.get<Group[]>(this.endpoint, { params })
  }

  public create(params: any): Observable<Group> {
    const type = params?.type === 'smart' ? 'smart' : 'static'
    return this.api.post<Group>(`${this.endpoint}/${type}`, params).pipe(map(response => response.result))
  }

  public addPersonasToGroups(groupIds: string, personaIds: string): Observable<void> {
    return this.api.put<void>(`${this.endpoint}/static/add_personas_to_groups`, {
      group_ids: groupIds,
      persona_ids: personaIds
    }).pipe(map(response => response.result))
  }

  public archive(params: ArchiveGroupParams): Observable<void> {
    const { id, type, name, archived } = params
    const payload: any = { archived }
    const t = type.toLowerCase() === 'smart group' ? 'smart' : 'static'
    if (t === 'static') payload.name = name
    return this.api.put<void>(`${this.endpoint}/${t}/${id}`, payload).pipe(map(response => response.result))
  }

}
